import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ImageButtonList from '../common/imageButtonList';
import ImageText from '../common/imageText';
import PatientBanner from '../common/patientBanner';
import NavigationBar from '../common/navigationBar';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';

class MealList extends Component {
  /**************
   * Properties *
   **************/
  state = {
    bannerVisible: {
      visible: true
    },
    navigationBar: {
      mainMenu: true,
      back: true,
      backRoute: '/main_menu'
    },
    header: {
      id: 'header',
      src: require('./images/intro/' + this.props.currentPatient + '_meals_intro.png'),
      top: 30,
      left: 63,
      width: 567,
      height: 487
    },
    buttons: [
      {
        id: 'breakfast',
        to: '/room_service/meal/breakfast',
        highlight: require('./images/intro/OrderBreakfast_intro_HL.png'),
        unhighlight: require('./images/intro/OrderBreakfast_intro_UH.png'),
        alt: 'Order Breakfast',
        checked: false
      },
      {
        id: 'lunch',
        to: '/room_service/summary/lunch',
        highlight: require('./images/intro/OrderLunch_intro_HL.png'),
        unhighlight: require('./images/intro/OrderLunch_intro_UH.png'),
        alt: 'Order Lunch',
        checked: true
      },
      {
        id: 'dinner',
        highlight: require('./images/intro/OrderDinner_intro_HL.png'),
        unhighlight: require('./images/intro/OrderDinner_intro_UH.png'),
        alt: 'Order Dinner',
        checked: true
      }
    ],
    buttonList: {
      top: 159,
      left: 728
    }
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1277">
        <ImageText {...this.state.header} />
        <PatientBanner {...this.state.bannerVisible} />
        <ImageButtonList {...this.state.buttonList} imageButtons={this.state.buttons} />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedMealList = connect(
  state => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(MealList);

export default withRouter(ConnectedMealList);
